import {http} from '@/http'

export default {
  list(data, params) {
    return http.post('/api/v1/users/list', data, {params})
  },
  save(data){
    return http.post('/api/v1/users', data)
  },
  get(id) {
    return http.get(`/api/v1/users/${id}`)
  },
  update(id, data) {
    return http.put(`/api/v1/users/${id}`, data)
  },
  toggleStatus(id, isActive) {
    return http.put(`/api/v1/users/${id}/active`, null, {
      params: {
        isActive,
      },
    });
  },
  resetPassword(id) {
    return http.patch(`/api/v1/users/${id}/reset-password`)
  },
  delete(id) {
    return http.delete(`/api/v1/users/${id}`);
  }
}
